import React from 'react';
import { useFeatureFlags } from 'components/shared/hooks';
import { UniversalDownloadComponent } from '@seismic/universal-download-component';
import { Button } from '@seismic/mantle';

const VideoDownloadButton = props => {
  const IsSeismicDownloadVideo = useFeatureFlags([
    'readiness-enable-seismic-download-video',
  ]);

  const items = [
    {
      repository: props.item.repository, // 'Learning'
      type: props.item.type, // 'externalvideo'
      id: props.item.id, // external video seismic id 'ff220422-3151-4388-9f11-b5e2a825519f'
    },
  ];

  const componentAs = props.componentAs || Button;

  const className =
    props.componentAs === Button
      ? 'u-resetBtn h-td-u c-link c-p p-0 mh-34 mr-4'
      : '';

  return (
    <>
      {IsSeismicDownloadVideo && (
        <UniversalDownloadComponent
          componentAs={componentAs}
          className={className}
          downloadOptions={{
            applicationWatermarkData: {
              application: 'ContentManager',
              viewerId: '1',
            },
            format: 'mp4',
            contentVersion: 2,
            token: 'fake Bearer token',
          }}
          items={items}
          label={t('common.download')}
          useExternalTheme={false}
        />
      )}
    </>
  );
};

export default VideoDownloadButton;
